import React from "react";

export const Work = () => {
  return (
    <div className="container">
      <h1>Work</h1>
    </div>
  );
};
